import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Flyout, Spinner } from '@a-ui/react';
import { useDispatch, useSelector } from 'react-redux'
import NotificationsMenu from './NotificationsMenu';
import NotificationsPrefs from './NotificationsPrefs';
import {
  fetchNotifications,
  fetchUnreadNotifications,
  setNotificationAsRead,
  lowerNotificationsCounter,
  resetNotifications,
} from '../../store/slices/notificationReducer';
import './NotificationsBell.scss';

const NotificationsBell = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const { loading, notificationsLoading, data } = useSelector(state => state.notifications);
  const { read, unread } = useSelector(state => state.notifications.inbox);
  const [showPreferences, setShowPreferences] = useState(false);
  const [openNotificationsMenu, setOpenNotificationsMenu] = useState(false);
  const [messages, setMessages] = useState([]);
  useEffect(() => {
    if(data) {
      const messages = data.map(message => {
        return {
          id: message.id,
          message: message.message,
          createdAt: message.createdAt,
          status: message.status,
        }
      });
      setMessages(messages);
    }
  }, [data]);

  useEffect(() => {
    const content = myRef.current.lastElementChild;
    content.onscroll = (e) => {
      const scrolledToEnd =  content.offsetHeight + content.scrollTop >= content.scrollHeight;
      if(scrolledToEnd && !notificationsLoading) {
        dispatch(fetchNotifications());
      }
    }
  }, [dispatch, notificationsLoading]);

  function mainFlyoutStateChange(state) {
    setOpenNotificationsMenu(!openNotificationsMenu);
    setShowPreferences(false);
    if (state) {
      dispatch(resetNotifications());
      dispatch(fetchNotifications());
    }
  }

  function notificationClicked(notification, unread) {
    dispatch(setNotificationAsRead(notification.id)).then(result => {
      if (!!unread) {
        dispatch(lowerNotificationsCounter());
      }
      setOpenNotificationsMenu(false);
      navigate(notification.url);
    });
  }

  function markAllAsRead(e) {
    e.preventDefault();
    dispatch(fetchUnreadNotifications()).then((unreadMessages) => {
      unreadMessages.payload.forEach(message => {
        dispatch(setNotificationAsRead(message.id)).then(result => {
          dispatch(lowerNotificationsCounter());
          message.status = "read";
        });
      });
    });
  }

  return <><Flyout
    orientation="bottom-right"
    onStateChange={(state) => mainFlyoutStateChange(state)}
    scrollable={true}
    hasPadding={false}
    open={openNotificationsMenu}
    ref={myRef}
    size="medium"
    trigger={<div className="trigger">
      <Button
        className="a-button--neutral a-button--text o-header__button"
        ariaLabel="Meldingen"
        addOn={{
          type: "icon",
          iconProps: {
            name: "ai-alarm-bell",
          },
        }}
      />
      {unread > 0 && <span className="a-badge">{unread}</span>}
    </div>}
    >
    <div className="u-text-left">
      <div className="o-notifications__title">
        <div className="u-margin-left">
          <h4>Meldingen{showPreferences && ' beheren'}</h4>
        </div>
        <Button
          className="a-button--neutral"
          ariaLabel="Beheer meldingen"
          emphasis="low"
          addOn={{
            type: "icon",
            iconProps: {
              name: showPreferences ? "ai-close" : "ai-cog-1",
            },
          }}
          onClick={() => { setShowPreferences(!showPreferences) }}
        />
      </div>
      {(unread === 0 && read === 0 && !showPreferences) && <p className="u-margin">Je hebt geen meldingen.</p>}
      {
        // eslint-disable-next-line
        (unread !== 0 && !loading && !showPreferences) && <p className="u-margin-left u-margin-bottom-xs"><a href="#" role="button" onClick={(e) => markAllAsRead(e)}>Alles als gelezen markeren</a></p>
      }
      {((unread !== 0 || read !== 0)  && !showPreferences) && <NotificationsMenu messages={messages} onNotificationClicked={(notification, unread) => notificationClicked(notification, unread)} />}
      {loading && !showPreferences && <div className="u-margin u-text-center"><Spinner/></div>}
      {showPreferences && <NotificationsPrefs/>}
    </div>
  </Flyout></>
}

export default NotificationsBell;
